import { SEEDED_HARNESS_ORG_ID } from '../flipper/seededHarnessOrg'
import { isHeyDolfinEmail } from '@dolfin/utils/email'

/**
 * Flipper AI bot profile ID (UUID) used for issue resolution comments.
 * Must match the id inserted in the migration 20260213110000_flipper_bot_profile.sql
 */
export const FLIPPER_BOT_ID = '00000000-0000-0000-0000-000000f11bbe' as const

/** Organization IDs for which Flipper AI is enabled. Other orgs do not see the toggle or trigger analysis. */
const SEEDED_COMPENSATION_INVESTIGATION_ORG_ID = 909002 as const

export const FLIPPER_ORG_IDS = [
  109,
  SEEDED_HARNESS_ORG_ID,
  SEEDED_COMPENSATION_INVESTIGATION_ORG_ID
] as const

export function isFlipperEnabledForOrg(organizationId: number | undefined | null): boolean {
  if (process.env.NODE_ENV === 'development') {
    return true
  }

  return organizationId != null && (FLIPPER_ORG_IDS as readonly number[]).includes(organizationId)
}

export function isFlipperEnabledForViewer({
  organizationId,
  email
}: {
  organizationId: number | undefined | null
  email?: string | null
}): boolean {
  return isHeyDolfinEmail(email) || isFlipperEnabledForOrg(organizationId)
}
